/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-26 15:15:35
 * @LastEditTime: 2022-03-24 16:42:50
 */
import i18n from "@/common/lang";
export const Columns = [
  { LabelName: i18n.t('lang.devicelist.SerialNumber'), row: 80, align: 'center', key: 0, ColumnsKey: 'Index', slot: true, },
  { LabelName: i18n.t('lang.collect.templateName'), key: 1, ColumnsKey: 'name', seek: 'tempName', sort: 'custom',placeholder:i18n.t('lang.FastAccess.pleaseName') },
  { LabelName: i18n.t('lang.collect.TemplateType'), key: 6, ColumnsKey: 'type', type: true, seek: 'tempType',select:true,selectOptions:[{label:"Modbus",value:"0"},{label:"IO Control",value:"1"}] },
  { LabelName: i18n.t('lang.collect.Updateddate'), key: 4, ColumnsKey: 'ts', sort: 'custom', isCustom: true, },
  { LabelName: i18n.t('lang.terminalList.describe'), key: 5, ColumnsKey: 'description' },
]

export const ColuumnsButton = [
  { key: 0, type: 'primary', icon: 'el-icon-edit', Fun: 'editCollection', Authority: 243 },
  { key: 1, type: 'danger', icon: 'el-icon-delete', Fun: 'deleteCollection', Delete: true, Authority: 244 },
]
